import Constants from "./../../constants/Constants";
import Player from "./Player";

class ComputerPlayer extends Player {

    play = async () => {
        this.resetSelectedProperties();

        if (this.overridePlay.override) {
            if (this.overridePlay.singleTimeUse === true) { this.overridePlay.override = false; }
            await this.overridePlay.fn();
            await this.gameCtx.waitFor(Constants.INTERVAL_AFTER_COMPUTER_PLAY);
            return;
        }

        let randNum = Math.floor(Math.random() * 11); 
        let entity, entityIndex

        if( randNum <= 9){
            entity = this.gameCtx.entitiesRepo.getNewPile()
            entityIndex = Constants.NEW_PILE_INDEX
        } else {
            entity = this.gameCtx.entitiesRepo.getUsedPile()
            entityIndex = Constants.USED_PILE_INDEX
        }

        // let newPile = this.gameCtx.entitiesRepo.getNewPile();
        let lastCardFromChosenPile = entity.getLastCard();

        if(lastCardFromChosenPile === null || lastCardFromChosenPile === undefined) {
            let newPile = this.gameCtx.entitiesRepo.getNewPile()
            lastCardFromChosenPile = newPile.getLastCard()
        }

        await this.gameCtx.moveCard(entityIndex, this.entityIndex, lastCardFromChosenPile);
        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);

        await this.onAfterPlayerGetCardFromNewPileOrUsedPile(lastCardFromChosenPile, this.entityIndex);

        if (this.overrideAfterOnAfterPlayerGetCardFromNewPileOrUsedPile) {
            this.overrideAfterOnAfterPlayerGetCardFromNewPileOrUsedPile = false;
            await this.gameCtx.waitFor(Constants.INTERVAL_AFTER_COMPUTER_PLAY);
            await this.levelToSixCards();
            return
        }

        this.chooseRandCard();

        await this.gameCtx.moveCard(this.entityIndex, Constants.USED_PILE_INDEX, this.chosenCard, true);

        await this.onAfterCardThrownFromPlayerToUsedPile(this.chosenCard);

        await this.gameCtx.waitFor(Constants.INTERVAL_AFTER_COMPUTER_PLAY);

        await this.levelToSixCards();
    }
}

export default ComputerPlayer;